import { render, staticRenderFns } from "./idle-modal.vue?vue&type=template&id=cdbec064&"
import script from "./idle-modal.vue?vue&type=script&lang=ts&"
export * from "./idle-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports